// extracted by mini-css-extract-plugin
export default {"melodyVideo":"eL-z","isFullWidth":"fL-z","landingPageVideo":"gL-z","play":"hL-z","iframeVideo":"iL-z","playHidden":"jL-z","fullwidth":"kL-z"};